import { useQuery } from '@tanstack/react-query';

import useOpenApiClient from './useOpenApiClient';

export function useReceipts() {
  const { apiFetch } = useOpenApiClient();

  return useQuery({
    queryKey: ['v1', 'receipts'],
    queryFn: async () =>
      apiFetch?.GET('/receipts').then((res) => {
        return res.data;
      }),
    refetchInterval: 5 * 1000,
  });
}
